//third party
import { ErrorHandler, Injectable, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "../../material.module";
import { ChartsModule } from '../charts/charts.module';
import { RichTextEditorModule } from '../rich-text-editor/rich-text-editor.module';
import { PipesModule } from "../../pipes/pipes.module";
import { Subject } from "rxjs";
import { AutoCompleteModule } from 'primeng/autocomplete';

//Widget Components
import { WidgetComponent } from "./widget.component";
import { WidgetMenuSettingsComponent } from "./widget-menu-settings.component";
import { ImageWidgetComponent } from "./image-widget/image-widget.component";
import { TextWidgetComponent } from "./text-widget/text-widget.component";
import { BarChartWidgetComponent } from "./bar-chart-widget/bar-chart-widget.component";
import { PieChartWidgetComponent } from "./pie-chart-widget/pie-chart-widget.component";
import { LineChartWidgetComponent } from "./line-chart-widget/line-chart-widget.component";
import { FuelGaugeChartWidgetComponent } from "./fuel-gauge-chart-widget/fuel-gauge-chart-widget.component";

//Widget Type Menu Setting Components
import { WidgetTypeMenuSettingsComponent } from "./widget-menu-settings/widget-type/widget-type-menu-settings.component";
import { WidgetBackgroundColourComponent } from "./widget-menu-settings/widget-background-colour/widget-background-colour.component";
import { WidgetGraphColourPresetsComponent } from "./widget-menu-settings/widget-graph-colour-presets/widget-graph-colour-presets.component";
import { ImageWidgetMenuSettingsComponent } from "./image-widget/settings/image-widget-menu-settings.component";
import { TextWidgetMenuSettingsComponent } from "./text-widget/settings/text-widget-menu-settings.component";
import { BarChartWidgetMenuSettingsComponent } from "./bar-chart-widget/settings/bar-chart-widget-menu-settings.component";
import { LineChartWidgetMenuSettingsComponent } from "./line-chart-widget/settings/line-chart-widget-menu-settings.component";
import { PieChartWidgetMenuSettingsComponent } from "./pie-chart-widget/settings/pie-chart-widget-menu-settings.component";
import { FuelGaugeChartWidgetMenuSettingsComponent } from "./fuel-gauge-chart-widget/settings/fuel-gauge-chart-widget-menu-settings.component";
import { WidgetControlTypeMenuSettingsComponent } from "./widget-menu-settings/widget-control-type/widget-control-type-menu-settings.component";

//Control Widgets Components
import { TextInputControlWidgetComponent } from "./control-widgets/text-input-control-widget/text-input-control-widget.component";

//Control Widgets Menu Settings Components
import { TextInputControlWidgetMenuSettingsComponent } from "./control-widgets/text-input-control-widget/settings/text-input-control-widget-menu-settings.component";

//Other Imports
import { WidgetDataSourceComponent } from "./widget-menu-settings/widget-datasource/widget-datasource.component";
import { WidgetMultiDataSourceComponent } from "./widget-menu-settings/widget-datasource/widget-multi-datasource/widget-multi-datasource.component";
import { WidgetSingleDataSourceComponent } from "./widget-menu-settings/widget-datasource/widget-single-datasource/widget-single-datasource.component";
import { NumberInputControlWidgetComponent } from "./control-widgets/number-input-control-widget/number-input-control-widget.component";
import { NumberInputControlWidgetMenuSettingsComponent } from "./control-widgets/number-input-control-widget/settings/number-input-control-widget-menu-settings.component";
import { DateTimeInputControlWidgetComponent } from "./control-widgets/datetime-input-control-widget/datetime-input-control-widget.component";
import { DateTimeInputControlWidgetMenuSettingsComponent } from "./control-widgets/datetime-input-control-widget/settings/datetime-input-control-widget-menu-settings.component";

import { EveUserAutoCompleteInputControlWidgetComponent } from "./control-widgets/eve-user-autocomplete-input-control-widget/eve-user-autocomplete-input-control-widget.component";
import { EveUserAutoCompleteInputControlWidgetMenuSettingsComponent } from "./control-widgets/eve-user-autocomplete-input-control-widget/settings/eve-user-autocomplete-input-control-widget-menu-settings.component";

import { FunctionNumberAutoCompleteInputControlWidgetComponent } from "./control-widgets/function-number-autocomplete-input-control-widget/function-number-autocomplete-input-control-widget.component";
import { FunctionNumberAutoCompleteInputControlWidgetMenuSettingsComponent } from "./control-widgets/function-number-autocomplete-input-control-widget/settings/function-number-autocomplete-input-control-widget-menu-settings.component";


@Injectable()
export class WidgetErrorHandler implements ErrorHandler {
  public isError$: Subject<Error | any> = new Subject();

  handleError(error) {
    //console.log('Intercepted error', error);
    this.isError$.next(error);
  }
}

@NgModule({
  exports: [
    CommonModule,
    WidgetComponent,
    WidgetMenuSettingsComponent,
    ImageWidgetComponent,
    TextWidgetComponent,
    BarChartWidgetComponent,
    PieChartWidgetComponent,
    LineChartWidgetComponent,
    FuelGaugeChartWidgetComponent,
    WidgetTypeMenuSettingsComponent,
    WidgetControlTypeMenuSettingsComponent,
    WidgetBackgroundColourComponent,
    WidgetGraphColourPresetsComponent,
    ImageWidgetMenuSettingsComponent,
    TextWidgetMenuSettingsComponent,
    BarChartWidgetMenuSettingsComponent,
    LineChartWidgetMenuSettingsComponent,
    PieChartWidgetMenuSettingsComponent,
    FuelGaugeChartWidgetMenuSettingsComponent,
    TextInputControlWidgetComponent,
    TextInputControlWidgetMenuSettingsComponent,
    NumberInputControlWidgetComponent,
    NumberInputControlWidgetMenuSettingsComponent,
    DateTimeInputControlWidgetComponent,
    DateTimeInputControlWidgetMenuSettingsComponent,
    EveUserAutoCompleteInputControlWidgetComponent,
    EveUserAutoCompleteInputControlWidgetMenuSettingsComponent,
    FunctionNumberAutoCompleteInputControlWidgetComponent,
    FunctionNumberAutoCompleteInputControlWidgetMenuSettingsComponent,

    WidgetDataSourceComponent,
    WidgetMultiDataSourceComponent,
    WidgetSingleDataSourceComponent
  ],
  declarations: [
    WidgetComponent,
    WidgetMenuSettingsComponent,
    ImageWidgetComponent,
    TextWidgetComponent,
    BarChartWidgetComponent,
    PieChartWidgetComponent,
    LineChartWidgetComponent,
    FuelGaugeChartWidgetComponent,
    WidgetTypeMenuSettingsComponent,
    WidgetControlTypeMenuSettingsComponent,
    WidgetBackgroundColourComponent,
    WidgetGraphColourPresetsComponent,
    ImageWidgetMenuSettingsComponent,
    TextWidgetMenuSettingsComponent,
    BarChartWidgetMenuSettingsComponent,
    LineChartWidgetMenuSettingsComponent,
    PieChartWidgetMenuSettingsComponent,
    FuelGaugeChartWidgetMenuSettingsComponent,
    TextInputControlWidgetComponent,
    TextInputControlWidgetMenuSettingsComponent,
    NumberInputControlWidgetComponent,
    NumberInputControlWidgetMenuSettingsComponent,
    DateTimeInputControlWidgetComponent,
    DateTimeInputControlWidgetMenuSettingsComponent,
    EveUserAutoCompleteInputControlWidgetComponent,
    EveUserAutoCompleteInputControlWidgetMenuSettingsComponent,
    FunctionNumberAutoCompleteInputControlWidgetComponent,
    FunctionNumberAutoCompleteInputControlWidgetMenuSettingsComponent,

    WidgetDataSourceComponent,
    WidgetMultiDataSourceComponent,
    WidgetSingleDataSourceComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ChartsModule,
    RichTextEditorModule,
    FormsModule,
    ReactiveFormsModule,
    AutoCompleteModule,

    PipesModule
  ],
  providers: [{ provide: ErrorHandler, useClass: WidgetErrorHandler }],
})
export class WidgetsModule { }



